import React from "react";
import { Spinner } from "reactstrap";

const FullPageLoader = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      height: "100vh",
    }}
  >
    <div style={{ flex: 1 }}>
      <Spinner color="secondary">{null}</Spinner>
      <div style={{ fontSize: "1.25em", paddingTop: ".25em" }}>Loading...</div>
    </div>
  </div>
);

export default FullPageLoader;
